import React, { useState, useEffect } from 'react';
import * as Util from '../../data/General';
import SelectHtml from './SelectHtml';
import { set } from 'date-fns';

function ListAudience(props) {
    const { sql } = props;
    const [audience, setAudience] = useState([]);
    const [show, setShow] = useState(false);
    const [isSearch, setSearch] = useState(false);

    const click = () => {
        setShow(true);
        setSearch(true);
        let queryJson={"query":sql};
        Util.executeQuery(queryJson, isOKQuery, isErrorQuery);
    }

    const cosed = () => {
        setShow(false);
        setAudience([]);
    }
    const isOKQuery = (data) => {
        setSearch(false);
        if(data && data.length > 0){
            setAudience(data);
        }
    }
    const isErrorQuery = (data) => {}
    
    return (
        <div className='container-audience'>
            <img src="/img/lista-de-contactos.png" className="click" alt="List" onClick={() => click()}/> 
            {show ? ( 
                <>
                    <div id="default-modal" tabindex="-1" aria-hidden="true" className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex">
                        <div className="relative p-4 w-full max-w-2xl max-h-full">
                            <div className="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                                <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                                        {Util.getMessage("audience_title")}
                                        <b>{isSearch ? ": ... ": (": " + (audience ? audience.length : "0"))}</b>
                                    </h3>
                                    <button type="button" onClick={() => cosed()} className="text-gray-400 click bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-hide="default-modal">
                                        <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                                        </svg>
                                        <span className="sr-only">Close modal</span>
                                    </button>
                                </div>
                                {isSearch ? (
                                    <div style={{display: "flex",justifyContent: "center",margin: "1rem"}}>
                                        <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                                    </div>
                                    ) : null}
                                <div className="p-4 list-content-audience">
                                    {audience && audience.length > 0 && audience.map((item, index) =>  (
                                        <div key={index} className='list-audience'>
                                            <div>{index+1}:</div>
                                            <div>{item.firstName + " " + item.lastName}</div>
                                            <div>{item.email}</div>
                                            <div>{item.phone}</div>
                                        </div>
                                    ))}
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div class="bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40"></div>
                </>
            ) : null}
        </div>
    );
}
    
export default ListAudience;
